module.exports = __webpack_public_path__ + "static/img/ic_kex_cobrand.2dbe1dc3.svg";